import { Calendar, CreditCard, Scissors } from "lucide-react";
import type { CalendarEvent } from "../../lib/types";

interface Props {
  events: CalendarEvent[];
}

const fmt = (n: number) =>
  n.toLocaleString("es-MX", { maximumFractionDigits: 0 });

const urgencyStyles = {
  red: { dot: "bg-red-500", text: "text-red-400", bg: "bg-red-500/10" },
  yellow: {
    dot: "bg-yellow-500",
    text: "text-yellow-400",
    bg: "bg-yellow-500/10",
  },
  green: {
    dot: "bg-emerald-500",
    text: "text-emerald-400",
    bg: "bg-emerald-500/10",
  },
};

export function PaymentTimeline({ events }: Props) {
  if (events.length === 0) {
    return (
      <div className="card p-6 text-center text-gray-500 text-sm">
        No hay eventos proximos
      </div>
    );
  }

  return (
    <div className="card overflow-hidden">
      <div className="px-4 py-3 border-b border-border flex items-center gap-2">
        <Calendar className="w-4 h-4 text-gray-500" />
        <h3 className="text-sm font-medium text-gray-300">
          Proximos 30 Dias
        </h3>
      </div>
      <div className="divide-y divide-border">
        {events.map((evt, i) => {
          const style = urgencyStyles[evt.urgency];
          const daysFromNow = Math.ceil(
            (new Date(evt.date).getTime() - Date.now()) / (1000 * 60 * 60 * 24)
          );
          const Icon = evt.type === "payment" ? CreditCard : Scissors;

          return (
            <div
              key={`${evt.card_id}-${evt.type}-${i}`}
              className={`px-4 py-3 flex items-center gap-3 ${style.bg}`}
            >
              <div className={`w-2 h-2 rounded-full flex-shrink-0 ${style.dot}`} />
              <Icon
                className="w-4 h-4 flex-shrink-0"
                style={{ color: evt.card_color }}
              />
              <div className="flex-1 min-w-0">
                <p className="text-sm text-gray-200">{evt.label}</p>
                <p className="text-xs text-gray-500">
                  Dia {evt.day} &middot; {evt.date}
                </p>
              </div>
              <div className="text-right flex-shrink-0">
                {evt.amount && (
                  <p className="text-sm text-gray-200">${fmt(evt.amount)}</p>
                )}
                <p className={`text-xs font-medium ${style.text}`}>
                  {daysFromNow <= 0 ? "HOY" : daysFromNow === 1 ? "MANANA" : `en ${daysFromNow}d`}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
